import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("hr", {
    class: _normalizeClass(["g-divider text-black-300-color", [{vertical: _ctx.vertical}]])
  }, null, 2))
}